import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { WorkSaveStatus } from '@ninety/platform/models/_shared/work-save-status';

export interface TrackedWork {
  id: string;
  component: string;
  feature?: string;
  status: WorkSaveStatus | null;
}

export type WorkSaveStatusState = EntityState<TrackedWork>;

export const workSaveStatusAdapter = createEntityAdapter<TrackedWork>();

export const initialWorkSaveStatusState: WorkSaveStatusState = workSaveStatusAdapter.getInitialState();
